import S from 'constants/string.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToString from 'utils/converters/fromAnyToString';
import withOptions from 'utils/functions/withOptions.util';

const parseText = withOptions(({ value: raw, noEmpty, noBlank }) => {
  const trimmed = fromAnyToTrimmed(raw);
  const string = fromAnyToString(raw);

  const empty = raw === '' || raw === null || raw === void 1;
  const blank = empty || !trimmed;
  const multiline = string.includes(S.newline);

  const valid = (noEmpty ? !empty : true) && (noBlank ? !noBlank : true);
  const is = { valid, empty, blank, multiline };

  return { string, trimmed, is, raw };
});

export default parseText;
